// SellerRetry.jsx
// Main component for seller onboarding retry flow

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styles, keyframes } from './styles';
import RetryHeader from './RetryHeader';
import RetryMessage from './RetryMessage';
import RetryInfoList from './RetryInfoList';
import ContinueButton from './ContinueButton';

const SellerRetry = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/profile');
  };

  return (
    <div style={styles.page}>
      <style>{keyframes}</style>
      <div style={styles.container}>
        <div style={styles.content}>
          <RetryHeader />
          <RetryMessage />
          <RetryInfoList />
          <ContinueButton onContinue={handleRetry} />
        </div>
      </div>
    </div>
  );
};

export default SellerRetry;